import { SENTRY_DSN } from '~/sentryDsn';

export const RELOAD_GUARD_MS = 60_000;
export const NOT_HYDRATED_AFTER_MS = 20_000;

export function sentryEnvelopeUrl(dsn: string): string {
  const parsed = new URL(dsn);
  return `${parsed.origin}/api${parsed.pathname}/envelope/?sentry_key=${parsed.username}&sentry_version=7`;
}

/** Plain ES5 kept bundle-free on purpose: it has to run when every chunk under /assets/ is gone. */
export function hydrationWatchdogScript(dsn: string, environment: string): string {
  const envelope = JSON.stringify(sentryEnvelopeUrl(dsn));
  const env = JSON.stringify(environment);
  return (
    `(function(){var KEY='ak:hydration-reload',ENVELOPE=${envelope},ENV=${env},sent=false;` +
    `function id(){var s='';for(var i=0;i<32;i++){s+=Math.floor(Math.random()*16).toString(16);}return s;}` +
    // The first modulepreload link is the entry chunk of this document, which dates the build that served it.
    `function build(){try{var l=document.querySelector('link[rel=modulepreload]');return l?l.getAttribute('href'):null;}catch(e){return null;}}` +
    `function report(reason,detail){if(sent){return;}sent=true;try{` +
    `var ev={event_id:id(),timestamp:Date.now()/1000,platform:'javascript',level:'warning',environment:ENV,` +
    `message:'hydration failure: '+reason,tags:{'hydration.reason':reason},` +
    `extra:{detail:detail,readyState:document.readyState,sinceLoadMs:Math.round(performance.now()),build:build()},` +
    `request:{url:location.href,headers:{'User-Agent':navigator.userAgent}}};` +
    `var body=JSON.stringify({event_id:ev.event_id,sent_at:new Date().toISOString()})+'\\n'+JSON.stringify({type:'event'})+'\\n'+JSON.stringify(ev);` +
    `if(navigator.sendBeacon){navigator.sendBeacon(ENVELOPE,body);}else{var x=new XMLHttpRequest();x.open('POST',ENVELOPE,true);x.send(body);}` +
    `}catch(e){}}` +
    `function reloadOnce(reason,detail){report(reason,detail);try{var last=Number(sessionStorage.getItem(KEY)||0);` +
    `if(Date.now()-last<${RELOAD_GUARD_MS}){return;}sessionStorage.setItem(KEY,String(Date.now()));}catch(e){return;}location.reload();}` +
    `window.addEventListener('error',function(e){try{if(window.__remixRouter){return;}var t=e&&e.target;if(!t||t.tagName!=='SCRIPT'||t.type!=='module'){return;}` +
    `var src=t.src||'';if(src&&src.indexOf(location.origin+'/assets/')!==0){return;}` +
    // Only Remix's inline module imports /assets/ chunks, so an inline module from anywhere else never reloads.
    `if(!src&&(t.text||'').indexOf('/assets/')===-1){return;}` +
    `reloadOnce('module-script-error',src?src.replace(location.origin,''):'inline-module');}catch(e){}},true);` +
    // Remix loads the entry via a dynamic import() whose failure only rejects a promise, never firing an error event.
    `window.addEventListener('unhandledrejection',function(e){try{if(window.__remixRouter){return;}var r=e&&e.reason,msg=String((r&&r.message)||r||'');` +
    `if(!/import/i.test(msg)||!/module/i.test(msg)){return;}` +
    // A message that names a module URL only counts when it is one of our own /assets/ chunks; Safari names none.
    `if(msg.indexOf('://')!==-1&&msg.indexOf(location.origin+'/assets/')===-1){return;}` +
    `reloadOnce('dynamic-import-error',msg.slice(0,200));}catch(e){}},true);` +
    `setTimeout(function(){try{if(window.__remixRouter||document.visibilityState==='hidden'){return;}` +
    `report('not-hydrated-after-${NOT_HYDRATED_AFTER_MS / 1000}s',document.readyState);}catch(e){}},${NOT_HYDRATED_AFTER_MS});` +
    `})();`
  );
}

export function HydrationWatchdog() {
  const environment = process.env.NODE_ENV === 'production' ? 'production' : 'development';
  return (
    <script
      suppressHydrationWarning
      dangerouslySetInnerHTML={{ __html: hydrationWatchdogScript(SENTRY_DSN, environment) }}
    />
  );
}
